import Vue from 'vue';
import Component from 'vue-class-component';
import {ProductGroup, Product} from '../../models/ProductModels';
import {Viewport} from '../../models/Viewport';
import ProductLink from './ProductLink.vue';
import ProductLinkSoftbook from './ProductLinkSoftbook';



@Component({
name:"product-subsection",
props:{
    productgroup: {

        
    },
    viewport:{

    }
},
components:{
    'product-link':ProductLink,
    'product-link-softbook':ProductLinkSoftbook
}
})

export default class ProductSubsectionComponent extends Vue{
productgroup:ProductGroup;
viewport:Viewport;
isSoftbookLink:boolean=false;


get productIds():string[]{

       // console.log("Products in a product-Group ", this.productgroup.productIds );
       
        return this.productgroup.productIds;

    }

    created(){
     //   console.log('isSoftbookLink', this.viewport.viewportEvironment);
        return this.isSoftbookLink=this.viewport.viewportEvironment==='softbook';
    }

}